// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Wm-z","tupacHeader":"Xm-z","tupacHeader2":"Ym-z","tupacMenu":"Zm-z","tupacMenu2":"_m-z","tupacMain":"an-z","tupacMain2":"bn-z"};